import { gql } from '@apollo/client';

/**
 * 拆分站点弹窗数据源（#5）：取站点的合并关联地址（address_source_type=2 且启用）——即被并入本站点的地址。
 * 对应 api-server CooperationWarehouseQuery.getStationAssociatedAddresses。带 relateId 供拆分迁移。
 */
export const GET_STATION_ASSOCIATED_ADDRESSES = gql`
  query GetStationAssociatedAddresses($cooperationWarehouseId: Long!) {
    getStationAssociatedAddresses(cooperationWarehouseId: $cooperationWarehouseId) {
      relateId
      addressLine1
      addressLine2
      city
      state
      zipcode
      sourceCooperationWarehouseId
    }
  }
`;

export interface StationAssociatedAddress {
  relateId: number;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  zipcode?: string | null;
  sourceCooperationWarehouseId?: number | null;
}

export interface GetStationAssociatedAddressesResponse {
  getStationAssociatedAddresses: StationAssociatedAddress[];
}

export interface GetStationAssociatedAddressesVariables {
  cooperationWarehouseId: number;
}
